/**
 * MLB team display helpers (SportsData may omit City; Wikipedia logo URLs may fail when hotlinked).
 */

/** Matches PHP `wins_league_mlb_display_timezone` default (`America/Chicago`). */
export const MLB_DISPLAY_TIMEZONE = "America/Chicago";

/**
 * Format game start from ISO instant in US Central with zone abbreviation (CDT/CST).
 *
 * @param {string|null|undefined} iso
 * @returns {string}
 */
export function formatMlbGameTimeCentral(iso) {
    if (!iso) {
        return "—";
    }
    try {
        const d = new Date(iso);
        if (Number.isNaN(d.getTime())) {
            return "—";
        }
        return new Intl.DateTimeFormat("en-US", {
            weekday: "short",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            timeZone: MLB_DISPLAY_TIMEZONE,
            timeZoneName: "short",
        }).format(d);
    } catch (e) {
        return "—";
    }
}

export function formatMlbTeamLabel(row) {
    if (!row) {
        return "";
    }
    return [row.city, row.name]
        .filter((x) => x != null && String(x).trim() !== "")
        .join(" ");
}

/** ESPN CDN fallback when primary logo URL fails to load. */
/**
 * Short date/time for upcoming-game rows (prefers ISO from API; falls back to WP-formatted `when`).
 *
 * @param {{ when?: string, start_iso?: string }|null|undefined} ng
 * @returns {string}
 */
export function formatMlbNextGameWhenCompact(ng) {
    if (!ng) {
        return "";
    }
    if (ng.start_iso) {
        const s = formatMlbGameTimeCentral(ng.start_iso);
        if (s && s !== "—") {
            return s;
        }
    }
    return ng.when || "";
}

export function mlbTeamLogoImgProps(teamKey, src) {
    return {
        className: "team_logo",
        src: src || "",
        alt: "",
        onError: (e) => {
            const el = e.currentTarget;
            if (el.dataset.wlFallback === "1") {
                return;
            }
            const k = String(teamKey || "")
                .toLowerCase()
                .replace(/[^a-z0-9]/g, "");
            if (!k) {
                return;
            }
            el.dataset.wlFallback = "1";
            el.src = `https://a.espncdn.com/i/teamlogos/mlb/500/${k}.png`;
        },
    };
}
